import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { filterFields } from "../../utils/search";

const styles = {
  container: {
    minWidth: 200,
    marginRight: 3.125,
    "&:last-child": {
      marginRight: 0,
    },
  },
};

const FieldSection = ({ label, fields, search, component: Checkbox }) => {
  const filteredFields = useMemo(() => filterFields(fields, search), [fields, search]);
  const sortedFields = useMemo(() => {
    return [...filteredFields].sort((a, b) => {
      const labelA = a[2] || '';
      const labelB = b[2] || '';
      return labelA.localeCompare(labelB);
    });
  }, [filteredFields]);

  if (sortedFields.length === 0) return null;

  return (
    <Box sx={styles.container}>
      <Box my={1}>
        <Typography color="textSecondary">{label}</Typography>
      </Box>
      <Box>
        {sortedFields.map(([name, category, label]) => (
          <Checkbox key={name} name={name} category={category} label={label} />
        ))}
      </Box>
    </Box>
  );
};

export default FieldSection;
